/* ==========================================================================
   Black Mango — Magnetic Buttons (Spring Physics)
   Elements with [data-magnetic] pull toward the cursor with elastic,
   rubber-band motion using springs from spring-physics.js.
   Respects prefers-reduced-motion.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    if ('ontouchstart' in window) return;

    const BMS = window.BlackMangoSpring;
    if (!BMS) return;

    const Spring = BMS.Spring;
    const activate = BMS.activate;

    const elements = document.querySelectorAll('[data-magnetic]');
    if (elements.length === 0) return;

    const RADIUS = 100;
    const MAX_MOVE = 10;

    for (const el of elements) {
      const sx = new Spring({ stiffness: 180, damping: 12, mass: 0.7 });
      const sy = new Spring({ stiffness: 180, damping: 12, mass: 0.7 });

      const entry = {
        step(dt) {
          sx.update(dt);
          sy.update(dt);
          el.style.transform =
            'translate(' + sx.value.toFixed(2) + 'px, ' + sy.value.toFixed(2) + 'px)';
        },
        isAtRest() { return sx.isAtRest(0.01) && sy.isAtRest(0.01); }
      };

      el.addEventListener('mousemove', function (e) {
        const rect = el.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dx = e.clientX - cx;
        const dy = e.clientY - cy;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < RADIUS) {
          const strength = 1 - dist / RADIUS;
          sx.target = dx * strength * (MAX_MOVE / RADIUS * 2);
          sy.target = dy * strength * (MAX_MOVE / RADIUS * 2);
        } else {
          sx.target = 0;
          sy.target = 0;
        }
        activate(entry);
      });

      el.addEventListener('mouseleave', function () {
        sx.target = 0;
        sy.target = 0;
        activate(entry);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
